import React, { useEffect, useState } from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'

import Footer from '../Footer/Main'
import AddGalleryPictureForm from '../AddGalleryPictureForm/Main'
import { getStrapiData } from '../../api.controller'

function Main() {

  const [data, setData] = useState();
  useEffect(() => {
    getStrapiData("gallery-page").then(response => {
      console.log(response);
      setData(response.data);
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <Header />
        <Breadcrumb data={data} subtitle="Home" title="Add Gallery Picture" />
        <AddGalleryPictureForm />
        <Footer />
      </div>
    </div>
  )
}

export default Main